import { useState, useEffect } from "react";
import axios from "axios";
import { Heart } from "lucide-react";
import { Button } from "../components/ui/button";
import { useAuth } from "../App";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const WishlistButton = ({ itemType, itemId, className = "" }) => {
  const { user } = useAuth();
  const [isWished, setIsWished] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) return;
    checkWishlist();
  }, [user, itemId]);

  const checkWishlist = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API}/wishlist`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        withCredentials: true
      });
      const found = res.data.items.some(i => i.item_id === itemId && i.item_type === itemType);
      setIsWished(found);
    } catch (e) {}
  };

  const toggle = async () => {
    if (!user) { toast.error("Please login to use wishlist"); return; }
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      if (isWished) {
        await axios.delete(`${API}/wishlist/remove/${itemType}/${itemId}`, { headers, withCredentials: true });
        setIsWished(false);
        toast.success("Removed from wishlist");
      } else {
        await axios.post(`${API}/wishlist/add`, { item_type: itemType, item_id: itemId }, { headers, withCredentials: true });
        setIsWished(true);
        toast.success("Added to wishlist");
      }
    } catch (e) {
      toast.error("Failed to update wishlist");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      disabled={loading}
      className={`${className} ${isWished ? "text-red-500" : "text-zinc-400 hover:text-red-500"}`}
      data-testid={`wishlist-btn-${itemId}`}
    >
      <Heart className={`w-5 h-5 ${isWished ? "fill-current" : ""}`} />
    </Button>
  );
};

export default WishlistButton;
